import Vue from 'vue'
import Vuex from 'vuex'
import api from '../request/api'
import createPersistedState from 'vuex-persistedstate'
import { Dialog, Toast } from 'vant'
import { formatTime, getAccountInfo } from '../utils/util'
import router from '../router'
Vue.use(Vuex)

var timerCont = null;

const store = new Vuex.Store({
  state: {
    connected: false,
    connectedPrinter: '',
    printing: false,//打印机是否在打印
    usb: '',//当前连接的打印机
    autoConnectCounter: 0,
    newMsg: 0,//
    storeDcArray: [],//抛入app.vue的打印队列
    log: [
    ],
    hcPrintList: {},//后厨打印记录列表，y_send_kitchen表主键，采用对象方法记录
    hcPrintSuccessListObject: {

    },//后厨打印成功映射
    hcPrintSuccessListArray: [],//后厨打印成功数组
    hcPrintSendSuccessList: {},//后厨打印成功发送数组映射
    hcPrintSendOnProgress: false,// 后厨修改打印状态接口开关
    displayDcArray: [],// 后厨展示用打印队列
    D2sPrinterConnect: false, // D2s打印机是否连接
    shop: {}, // 门店信息
    paySuccess: false,
    nowVersion: '3.8.0',
    hcPrintCount: 0, // 后厨打印失败次数
    qtPrintCount: 0, // 前台打印失败次数
    deviceIp: '',
    deviceMac: '',
    bindStatus: '', // 本机是否绑定了打印机
    weightDetail: {
      net: 0,
      weight: 0,
      status: 0,
      grossWeight: 0,
      overflow: ''
    }, // 重量对象对象
    outDeviceList: [], // 搜索到的设备列表
    deviceInfo: {
      ip: ''
    }, // 设备信息
    outDevice: {}, // 连接的设备名称
    digits: 2, // 金额保留小数位数
    fastFoodList: [],// 快餐餐品列表
    FoodList: [], // 开台餐品列表
    isCutPage: '1', // 安卓是否切纸 0不切 1切纸
    allFoodList: [], // 菜单管理菜品
    noticeList: [], // 顶部导航栏消息
    hcPrintRes: {
      code: 0, // 1： 正在打印 2： 打印结束 3： 打印失败，请重新连接
      msg: '打印失败，请重新连接打印机',
    }, // 安卓后厨网络打印成功回调信息
    stagingFood: {}, // 新增编辑菜品去添加规格设置的一些暂存信息
    stagingSpec: [], // 新增编辑完规格后对规格设置信息暂存
    stagingHcErr: {}, // 后厨打印对应IP打印错误时写入1次，重复进行连接三次，如果依旧失败，则从打印队列删除
    businessModel: {
      open_tabel: '', // 开台模块是否开启 1开启  0关闭
      self_pickup: '', // 点餐模块是否开启
      take_away: '', // 外卖模块是否开启
    },
    showOrderLoading: false, // 订单列表加载动画是否展示
    nowTimeStr: '', // 当前时间展示
    pack_or_dineIn: '', // 1：打包   2：堂食
    labelDeviceList: [], // 搜索到的标签打印机
    labelPrintCount: 0,
    otherVoice: [],
    usbConnectStatus: {}, // 安卓USB打印机连接状态
    labelConnectStatus: {}, // 安卓标签打印机连接状态
    labelPrintStatus: {}, // 安卓标签打印机打印状态
    tagPrinter: [], // 系统中获取到的标签打印机
    qtPrinter: {}, // 系统中获取到的前台打印机
    reprintHcFoodRefresh: false, // 刷新后厨做菜单打印失败日志
    mtPrinterStatus: {}, // 美团内置打印机状态
    mtScale: {}, // 美团内置电子秤
    bluetoothDeviceIos: [], // iOS  搜到的蓝牙标签打印机
    blelabelConnectStatus: {}, // iOS蓝牙标签机连接状态
    unorderCount: 0, // 订单（未结订单）数量
    $shopLevel: 1, // 如果data 是 0  需要访问 新得接口地址;如果data 是 1  还是访问我们原先得
    isShowNotify: false, // 是否显示通知提示
    notifyContent: '',
    is_show_sidebar: false,
    package_grouping: [], // 暂存的套餐分组
    show_pay_tip: false, // 是否显示付费提示
  },
  getters: {
    log: state => state.log,
    hcPrintList: state => state.hcPrintList,
    displayDcArray: state => state.displayDcArray,
    shop: state => state.shop,
    weightDetail: state => state.weightDetail,
    outDeviceList: state => state.outDeviceList,
    deviceInfo: state => state.deviceInfo,
    digits: state => state.digits,
    fastFoodList: state => state.fastFoodList,
    FoodList: state => state.FoodList,
    isCutPage: state => state.isCutPage,
    allFoodList: state => state.allFoodList,
    noticeList: state => state.noticeList,
    hcPrintRes: state => state.hcPrintRes,
    stagingHcErr: state => state.stagingHcErr,
    businessModel: state => state.businessModel,
    labelDeviceList: state => state.labelDeviceList,
    bluetoothDeviceIos: state => state.bluetoothDeviceIos,
    $shopLevel: state => state.$shopLevel,
  },
  mutations: {
    updateShowPayTip (state, val) {
      state.show_pay_tip = val;
    },
    setPackageGrouping(state, val) {
      state.package_grouping = val;
    },
    updateIsShowSidebar(state, val) {
      state.is_show_sidebar = val;
    },
    updateNotifyContent(state, val) {
      state.notifyContent = val;
    },
    updateIsShowNotify(state, val) {
      state.isShowNotify = val;
    },
    deleteshopLevel(state) {
      delete state.$shopLevel
    },
    setShopLevel(state, val) {
      state.$shopLevel = val;
    },
    setUnorderCount(state, val) {
      state.unorderCount = val;
    },
    updateBlelabelConnectStatus(state, val) {
      state.blelabelConnectStatus = val;
    },
    updateBluetoothDeviceIos(state, val) {
      state.bluetoothDeviceIos = val;
    },
    updateMtScale(state, val) {
      state.mtScale = val;
    },
    updateMtPrinterStatus(state, val) {
      state.mtPrinterStatus = val;
    },
    updateReprintHcFoodRefresh(state, val) {
      state.reprintHcFoodRefresh = val;
    },
    updateQtPrinter(state, val) {
      state.qtPrinter = val;
    },
    updateTagPrinter(state, val) {
      state.tagPrinter = val;
    },
    updateLabelPrintStatus(state, val) {
      state.labelPrintStatus = val;
    },
    updateLabelConnectStatus(state, val) {
      state.labelConnectStatus = val;
    },
    updateUsbConnectStatus(state, val) {
      state.usbConnectStatus = val;
    },
    updateOtherVoice(state, val) {
      state.otherVoice = val;
    },
    updateLabelPrintCount(state, val) {
      state.labelPrintCount = val;
    },
    // 更新标签设备列表
    updateLabelDeviceList(state, val) {
      state.labelDeviceList = val;
    },
    updatePackOrDineIn(state, val) {
      state.pack_or_dineIn = val;
    },
    updateShowOrderLoading(state, val) {
      state.showOrderLoading = val;
    },
    updateBusinessModel(state, val) {
      state.businessModel = val;
    },
    updateStagingHcErr(state, val) {
      state.stagingHcErr = val;
    },
    updateStagingSpec(state, val) {
      state.stagingSpec = val;
    },
    updateStagingFood(state, val) {
      state.stagingFood = val;
    },
    updateHcPrintRes(state, val) {
      state.hcPrintRes = val;
    },
    // 更新消息列表
    updateNoticeList(state, val) {
      state.noticeList = val;
    },
    // 更新开台餐品列表
    updateFoodList(state, val) {
      state.FoodList = val
    },
    // 更新快餐列表
    updateFastFoodList(state, val) {
      state.fastFoodList = val
    },
    // 更新设备信息
    updateDeviceInfo(state, val) {
      state.deviceInfo = val;
    },
    // 更新设备列表
    updateOutDeviceList(state, val) {
      state.outDeviceList = val;
    },
    // 更新电子称重量
    updateWeightDataDetail(state, data) {
      state.weightDetail = data;
    },
    updateDigits(state, val) {
      state.digits = val;
    },
    updateWeightDetail(state, val) {
      state.weightDetail = val;
    },
    updateBindStatua(state, val) {
      state.bindStatus = val;
    },
    updateDeviceIp(state, val) {
      state.deviceIp = val;
    },
    updateDeviceMac(state, val) {
      state.deviceMac = val;
    },
    UPDATE_PAYSUCCESS(state, status) {
      state.paySuccess = status
    },
    updateDisplayDcArray(state, val) {
      state.displayDcArray = val;
    },
    // 设置后厨修改打印状态接口开关
    setHcPrintSendOnProgress(state, val) {
      state.hcPrintSendOnProgress = val;
    },
    // 添加后厨打印成功发送数组映射
    addHcPrintSendSuccessList(state, num) {
      state.hcPrintSendSuccessList[num] = true;
      // console.log('后厨成功打印映射表', state.hcPrintSendSuccessList);
    },
    // 添加后厨打印成功映射纪录
    addHcPrintSuccessList(state, num) {
      //num 为 y_send_kitchen表主键
      state.hcPrintSuccessListObject[num] = true;
      state.hcPrintSuccessListArray.push(num);
      // console.log('后厨成功打印映射表', state.hcPrintSuccessListObject, state.hcPrintSuccessListArray);
    },
    // 添加后厨打印映射纪录
    addHcPrintList(state, num) {
      //num 为 y_send_kitchen表主键
      state.hcPrintList[num] = true;
      // console.log('后厨打印映射表', state.hcPrintList);
    },
    // 改变打印log的is_print值
    changeLogPrintStatus(state, print_uuid) {
      var index = state.log.findIndex(e => e.print_uuid == print_uuid);
      if (index != -1) {
        state.log[index].is_print = true;
      }
    },
    // 添加一条打印log纪录
    addLog(state, msg) {
      // console.log('addLog', msg)
      let index = state.log.length + 1;
      state.log.unshift(Object.assign({ id: index }, { is_print: false }, msg));
    },
    setDcArray(state, val) {
      state.storeDcArray.push(...val);
      state.newMsg++;
    },
    clearDcArray(state, val) {
      state.storeDcArray = [];
    },
    setUSB(state, val) {
      state.usb = val;
    },
    setConnect(state, val) {
      state.connected = val;
    },
    setConnectedPrinter(state, val) {
      state.connectedPrinter = val;
    },
    setAutoConnectCounter(state, val) {
      state.autoConnectCounter = val;
    },
    setPrinting(state, val) {
      state.printing = val;
    },
    setD2sPrinterConnect(state, bool) {
      state.D2sPrinterConnect = bool;
    },
    setShopInfo(state, val) {
      state.shop = val;
    },
    updateHcPrintCount(state, val) {
      // console.log('!!!!!!!!', val);
      state.hcPrintCount = val;
    },
    updateQtPrintCount(state, val) {
      state.qtPrintCount = val;
    },
    updateNowTimeStr(state, val) {
      state.nowTimeStr = val;
    }
  },
  actions: {
    getNotifyData(context, data) {
      api.upgradeRemind().then(res => {
        if (res.code == 1 && res.data && res.data != '') {
          context.commit('updateNotifyContent', res.data);
          context.commit('updateIsShowNotify', true);
        } else {
          context.commit('updateIsShowNotify', false);
          context.commit('updateNotifyContent', '');
        }
      })
    },
    // getCheckShopLevel(context, data) {
    //   const account = getAccountInfo('phone');
    //   const password = getAccountInfo('password');
    //   if (!account || !password) {
    //     Dialog.alert({
    //       title: '提示',
    //       message: '登录信息过期，需要重新登录'
    //     }).then(() => {
    //       router.replace({
    //         path: '/login'
    //       });
    //       localStorage.removeItem('token')
    //     })
    //     return;
    //   }
    //   return new Promise((resolve, reject) => {
    //     let query = new FormData();
    //     query.append('account', account);
    //     query.append('password', password);
    //     api.checkShopLevel(query).then(res => {
    //       if (res.code == 1) {
    //         context.commit('setShopLevel', res.data.toString() == '' ? 1 : res.data);
    //         resolve();
    //       } else {
    //         Toast(res.msg || '获取门店类型失败');
    //         resolve();
    //       }
    //     }).catch(() => {
    //       Toast('获取门店类型失败');
    //       resolve();
    //     })
    //   })
    // },
    setNowTimeStr(context, data) {
      clearInterval(timerCont);
      timerCont = null;
      if (localStorage.token) {
        timerCont = setInterval(() => {
          let nowTime = formatTime(new Date(), 'yyyy-MM-dd hh:mm:ss');
          context.commit('updateNowTimeStr', nowTime);
        }, 1000);
      } else {
        clearInterval(timerCont);
        timerCont = null;
        context.commit('updateNowTimeStr', '');
      }
    },
    getShopBusinessModel(context, data) {
      api.getBusinessModel().then(res => {
        if (res.code == 1) {
          context.commit('updateBusinessModel', res.data);
        } else {
          Toast(res.msg || '获取经营模式配置失败');
          context.commit('updateBusinessModel', { open_tabel: '', self_pickup: '', take_away: '' });
        }
      }).catch(() => {
        Toast('获取经营模式配置失败');
        context.commit('updateBusinessModel', { open_tabel: '', self_pickup: '', take_away: '' });
      })
    },
    setShopInfo(context, data) {
      // console.log("%c 🍺 dispatch setShopInfo", "color:#3f7cff", data);
      context.commit('setShopInfo', data)
      setTimeout(() => {
        let objData = {
          uid: localStorage.uid,
          shop_id: data.id || 0,
          shop_name: data.name,
          phone: data.phone,
        }
        localStorage.setItem("dcServerData", JSON.stringify(objData))
      }, 500)
    },
    getStoreInfo(context, data) {
      return new Promise((resolve, reject) => {
        api.getShopInfo().then(res => {
          if (res.code == 1) {
            context.dispatch("setShopInfo", res.data);
            localStorage.setItem('scale_type', res.data.scale_type || '');
            localStorage.setItem('box_type', res.data.box_type || '');
            resolve();
          }
        })
      })
    },
  },
  plugins: [
    // 可以有多个持久化实例
    createPersistedState({
      key: 'vuex', // 状态保存到本地的 key
      paths: ['businessModel', '$shopLevel', 'tagPrinter'], // 要持久化的状态，在state里面取，如果有嵌套，可以  a.b.c
    })
  ]

})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js